import { appConfig } from "src/config";
import { reroll } from "../components/PageSetRouter";

export default {
  userPortalHomePage() {
    window.location.href = appConfig.USERPORTAL_URL;
  },

  cancelSubscription(isHM: boolean, isInTrial: boolean) {
    const program = isHM ? "/hm" : "";
    const cancelUrl = isInTrial ? "trial-cancel" : "cancel";

    const nextUrl = `/subscription${program}/${cancelUrl}`;
    reroll(nextUrl, new URLSearchParams(window.location.search), true);
  },
};
